import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS, SUPPORTED_PAGES } from "../../_builder-constants";

const TAB_SCHEMA = [
  { key: "label", label: "Tab Label", type: "string" as const },
];

export const schema: ComponentSchema = {
  type: "product-slider",
  label: "Product Slider",
  description: "A horizontal scrolling product carousel with optional tabs.",
  supportedPages: ["home", "category", "categories"] as typeof SUPPORTED_PAGES[number][],
  variants: [
    {
      id: "v1",
      label: "V1 — Tabbed carousel",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Featured Products" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "All Product Shop" },
        { key: "tabs", label: "Tabs", type: "array", itemSchema: TAB_SCHEMA },
      ],
    },
    {
      id: "v2",
      label: "V2 — Simple Jewelry Carousel (3-4 cols)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "New Arrivals" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Exquisite Collection" },
      ],
    },
    {
      id: "v3",
      label: "V3 — Beauty Product Carousel",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Skincare & Beauty" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Glow Up Collection" },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
